module.exports = __webpack_public_path__ + "img/header-darkmode@2x.5ac418f8.png";